import { Injectable } from '@angular/core';

import { OccStoreFinderAdapter } from '@spartacus/storefinder/occ';

@Injectable()
export class DpOccStoreFinderAdapter extends OccStoreFinderAdapter {}
